import { createSelector, createStructuredSelector } from "reselect";

export const soloLookupSelector = createSelector(
  state => state.soloUIDLookup.getIn(["soloUIDLookup"]),
  x => x.toJS()
);

export default createStructuredSelector({
  soloUIDLookup: soloLookupSelector
});
